<template>
    <div>
        <Button type="primary" @click="modal = true" v-hasPermission="['configurationManagement:systemTask:add_timed_task']">{{ $t('configuration_management.system_task.addSystemTask') }}</Button>
        <Modal v-model="modal" :title="$t('configuration_management.system_task.addSystemTask')" :loading="loading" @on-ok="systemTaskSubmit('systemTaskForm')" @on-cancel="systemTaskReset('systemTaskForm')" :mask-closable="false">
            <Form ref="systemTaskForm" :model="systemTaskForm" :label-width="100" :rules="ruleValidate">
                <!-- bean名称 -->
                <FormItem :label="$t('configuration_management.system_task.beanName')" prop="beanName">
                    <Input v-model="systemTaskForm.beanName"  style="width:260px;"/>
                </FormItem>

                <!-- 方法名称 -->
                <FormItem :label="$t('configuration_management.system_task.methodName')" prop="methodName">
                    <Input v-model="systemTaskForm.methodName"  style="width:260px;"/>
                </FormItem>

                <!-- 方法参数 -->
                <FormItem :label="$t('configuration_management.system_task.methodParameter')" prop="methodParams">
                    <Input v-model="systemTaskForm.methodParams"  style="width:260px;"/>
                </FormItem>

                <!-- cron表达式 -->
                <FormItem :label="$t('configuration_management.system_task.cronExpressioin')" prop="cronValue">
                    <input-cron type="text" v-model="systemTaskForm.cronValue" style="width:315px;"/>
                </FormItem>

                 <!-- 状态 -->
                <FormItem :label="$t('configuration_management.system_task.status')" prop="state">
                    <RadioGroup v-model="systemTaskForm.state">
                        <Radio v-for="list in stateList" :label="list.state" :key="list.value">{{list.label}}</Radio>
                    </RadioGroup>
                </FormItem>

                <!-- 备注 -->
                <FormItem :label="$t('configuration_management.system_task.note')" prop="remark">
                    <Input v-model="systemTaskForm.remark" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="Enter something..." style="width:300px;"></Input>
                </FormItem>
                
            </Form>
        </Modal>
    </div>
</template>
<script>
    import InputCron from '../../../easy_cron/input-cron'
    import CronValidator from '../../../easy_cron/validator'
    import {setCookie,getCookie} from '../../../../utils/cookieUtil.js'
    import TableSystemTask from '../system_task/TableSystemTask.vue'
    var tableSystemTask = TableSystemTask;
    export default {
        components: {
            InputCron
        },
        data () {
            return {
                systemTaskForm: {
                    beanName: '',
                    methodName:'',
                    methodParams:'',
                    state:'1',
                    remark:'',
                    cronValue:''
                },
                loading: true,
                modal:false,
                stateList: [{
                    label: this.$t('configuration_management.system_task.ok'),
                    value: 'normal',
                    state: '1'
                },{
                    label: this.$t('configuration_management.system_task.paused'),
                    value: 'suspend',
                    state: '0'
                }],
                ruleValidate: {
                    beanName: [
                        { required: true, message: this.$t('configuration_management.system_task.pleaseEnterBeanName'), trigger: 'blur' },
                        { message: this.$t('configuration_management.system_task.beanNamePattern'), pattern:'^[A-Za-z0-9]{1,20}$', trigger: 'blur'}
                    ],
                    methodName: [
                        { required: true, message: this.$t('configuration_management.system_task.pleaseEnterMethodName'), trigger: 'blur' },
                        { message: this.$t('configuration_management.system_task.methodNamePattern'), pattern:'^[A-Za-z0-9]{1,20}$', trigger: 'blur'}
                    ],
                    methodParams: [
                        { required: false, message: this.$t('configuration_management.system_task.pleaseEnterMethodParameter'), trigger: 'blur' }
                    ],
                    cronValue: [
                        { required: true,validator: CronValidator }
                    ],
                    state: [
                        { required: true, message: this.$t('configuration_management.system_task.pleaseSelectStatus'), trigger: 'change' }
                    ],
                    remark: [
                        { required: false, message: this.$t('configuration_management.system_task.pleaseEnterNote'), trigger: 'blur'},
                        { type: 'string', max: 100, message: this.$t('configuration_management.common.max100Characters'), trigger: 'blur' }
                    ]
                }
            }
        },
        methods:{
            systemTaskSubmit: function(name){
                this.$refs[name].validate(valid => {
                    if(valid){
                        // 添加联系人
                        this.$api.systemTask.createSystemTask({
                            "beanName": this.systemTaskForm.beanName,
                            "methodName": this.systemTaskForm.methodName,
                            "methodParams": this.systemTaskForm.methodParams,
                            "cronExpression": this.systemTaskForm.cronValue,
                            "state": this.systemTaskForm.state,
                            "remark": this.systemTaskForm.remark,
                            "createdBy": getCookie(global.cookieName),
                            "modifiedBy": getCookie(global.cookieName)
                        })
                        .then(res => {
                            this.data = res.data;
                            setTimeout(() => {
                                tableSystemTask.methods.showAll();
                                this.$refs[name].resetFields();
                                this.loading = false;
                                this.$nextTick(() => {
                                    this.loading = true;
                                });
                                this.$Message.success(this.$t('common.addSuccess'));
                                this.modal = false;
                            },1000);
                        })
                    }else{
                        //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
                        this.loading = false;
                        setTimeout(() => {
                            this.loading = true
                        }, 0)
                        this.$Message.error(this.$t('common.addFail'));
                    }
                });
            },
            systemTaskReset: function(name){
                this.$refs[name].resetFields();
            }
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/system_task/AddSystemTask.vue